export default {
  namespaced: true,
  state: {
    items: [],
    material_retrieving_places: [
      {
        value: "agency",
        text: "Retour depuis une agence"
      },
      {
        value: "project",
        text: "Retour depuis un chantier"
      },
      {
        value: "other",
        text: "Autre lieu"
      },
      {
        value: "axiloc",
        text: "Dépôt à l'entrepôt ESM"
      },
      {
        value: "chronopost",
        text: "Retour Chronopost"
      }
    ],
    material_retrieving_places_colors: {
      agency: "#2b97fc",
      project: "#fe8d0b",
      other: "#cd0bfe",
      chronopost: "#ffb71c",
      axiloc: "#1AAE7C"
    }
  },
  getters: {
    getAll: state => state.items,
    getByStatus: state => status => state.items.filter(item => item.status_id == status || item.status.id == status),
    getByStatusSlug: state => status => state.items.filter(item => item.status_slug == status || item.status.status_slug == status),
    getItem: state => id => state.items.find(item => item.id == id),
    getMaterialRetrievingPlaces: state => state.material_retrieving_places,
    getMaterialRetrievingPlaceBySlug: state => slug => state.material_retrieving_places.find(item => item.value == slug),
    getMaterialRetrievingPlaceColorBySlug: state => slug => state.material_retrieving_places_colors[slug],
  },
  actions: {

    /**
     * Charge tous les items via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns {promise}       Aucune donnée n'est retournée
     */
    getAll: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'businessreturn',
        api_data_path: 'businessReturns',
        namespace: 'business_return'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    /**
     * Charge tous les items d'un (ou plusieurs) statut via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   array   status  Status
     * @param   boolean wait    Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns promise         Aucune donnée n'est retournée
     */
    getByStatusSlug: (context, status, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'businessreturn/by/status',
        api_data_path: 'businessReturns',
        namespace: 'business_return',
        query: 'status=' + status.join('|')
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    /**
     * Charge tous les items via l'API dans le state avec des données limitées. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns {promise}       Aucune donnée n'est retournée
     */
    getAllForSelect: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'businessreturn/index/simple',
        api_data_path: 'businessReturns',
        namespace: 'business_return'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    getItem: (context, {
      id,
      wait = false
    }) => {
      let params = {
        wait: wait,
        api_url: 'businessreturn',
        namespace: 'business_return',
        id: id
      }
      return context.dispatch('getItem', params, {
        root: true
      })
    },
    addItem(context, item) {
      let params = {
        api_url: 'businessreturn',
        namespace: 'business_return',
        item: item
      }
      return context.dispatch('addItem', params, {
        root: true
      })
    },
    saveItem(context, item) {
      let params = {
        api_url: 'businessreturn',
        namespace: 'business_return',
        item: item
      }
      return context.dispatch('saveItem', params, {
        root: true
      })
    },
    deleteItem(context, id) {
      let params = {
        api_url: 'businessreturn',
        namespace: 'business_return',
        id: id
      }
      return context.dispatch('deleteItem', params, {
        root: true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/business_return.js